function smallScreenDetect() {
    const viewportWidth = window.innerWidth;
    if (viewportWidth >= 768 && viewportWidth <= 1250) {
        document.body.dataset.smallScreen = true;
    } else {
        document.body.dataset.smallScreen = false;
    }
}

window.addEventListener('resize', smallScreenDetect);
window.addEventListener('load', smallScreenDetect);